const Calculator = (discount, price) => {
    if (discount.discount_type_id == 1)
        return Number(price) - discount.value
    else if (discount.discount_type_id == 2)
        return Number(price) - (Number(price) * (discount.value / 100))
}
const CalculateAmound = (discount, price) => {
    if (discount.discount_type_id == 1)
        return discount.value
    else if (discount.discount_type_id == 2)
        return Number(price) * (discount.value / 100)
}
export { CalculateAmound };
export default Calculator;